import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import { ITooltip } from '../../../components/1elements'

const HMapDisplaySearch = ({
  currentTab,
  sortSearch,
  setSortSearch
}) => {
  const [isSearchBoxOpen, SetIsSearchBoxOpen] = useState(false)
  const [searchText, setSearchtext] = useState('')
  const classes = useStyles({ isSearchBoxOpen })

  const handleOnKeyDown = (e) => {
    if (e.keyCode === 13) {
      handleSearchButtonClick()
    }
  }

  const handleSearchButtonClick = () => {
    // if the search component is minimized
    if (!isSearchBoxOpen) return SetIsSearchBoxOpen(true)

    // if the search component is open
    setSortSearch({
      ...sortSearch,
      [currentTab]: {
        ...sortSearch[currentTab],
        searchText: searchText
      }
    })
  }

  const handleClearButtonClick = () => {
    setSearchtext('')

    setSortSearch({
      ...sortSearch,
      [currentTab]: {
        ...sortSearch[currentTab],
        searchText: ''
      }
    })

    SetIsSearchBoxOpen(false)
  }

  const searchTextChange = (e) => {
    setSearchtext(e.target.value)
  }

  useEffect(() => {
    const { searchText } = sortSearch[currentTab]

    // If there is no search text for the currentTab
    if (!searchText) return handleClearButtonClick()

    // If there is a search text for currentTab
    setSearchtext(searchText)
    SetIsSearchBoxOpen(true)

    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [currentTab])

  return (
    <ITooltip
      placement={'bottom'}
      content={'Search Heatmaps'}
      showTooltip={!isSearchBoxOpen}
    >
      <div className={classes.root}>
        <input
          type="text"
          className={classes.searchTextbox}
          value={searchText}
          onChange={searchTextChange}
          disabled={!isSearchBoxOpen}
          onKeyDown={handleOnKeyDown}
        />
        <SearchIcon
          className={classes.searchIcon}
          onClick={handleSearchButtonClick}
        />
        {isSearchBoxOpen && (
          <ClearIcon
            className={classes.clearIcon}
            onClick={handleClearButtonClick}
          />
        )}
      </div>
    </ITooltip>
  )
}

export default React.memo(HMapDisplaySearch)

const useStyles = makeStyles((theme, props) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover> svg': {
      fill: (props) => !props.isSearchBoxOpen && theme.palette.primary.accent
    },
    '&:hover> input': {
      border: (props) =>
        !props.isSearchBoxOpen && `2px solid ${theme.palette.primary.accent}`
    }
  },
  searchTextbox: {
    position: 'relative',
    width: (props) => (!props.isSearchBoxOpen ? '30px' : '150px'),
    height: '30px',
    padding: (props) => (!props.isSearchBoxOpen ? '0' : '0 30px 0 30px'),
    borderRadius: '5px',
    border: `2px solid #9A9A9A`,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#9A9A9A',
    transition: 'ease-out width .25s',
    '&:hover': {
      border: (props) =>
        (!props.isSearchBoxOpen && `2px solid ${theme.palette.primary.accent}`)
    },
    '&:focus': {
      outline: 'none'
    }
  },
  searchIcon: {
    position: 'absolute',
    top: 3,
    left: (props) => (!props.isSearchBoxOpen ? 3 : 5),
    fill: '#9A9A9A',
    '&:hover': {
      fill: theme.palette.primary.accent
    }
  },
  clearIcon: {
    position: 'absolute',
    top: 3,
    right: 5,
    fill: '#9A9A9A',
    '&:hover': {
      fill: theme.palette.primary.accent
    }
  }
}))
